export default "__VITE_ASSET__BeY6voB1__"